import styled from 'styled-components'

import { DomUtil } from '@root/shared'

import DIAMOND_1 from './assets/d-1.inline.webp'
import DIAMOND_2 from './assets/d-2.inline.webp'
import DIAMOND_3 from './assets/d-3.inline.webp'
import ELITE from './assets/e.inline.webp'
import GOLD_1 from './assets/g-1.inline.webp'
import GOLD_2 from './assets/g-2.inline.webp'
import GOLD_3 from './assets/g-3.inline.webp'
import PLATINUM_1 from './assets/p-1.inline.webp'
import PLATINUM_2 from './assets/p-2.inline.webp'
import PLATINUM_3 from './assets/p-3.inline.webp'
import SPLASH_POINTS from './assets/splash-points.inline.webp'

import type { PremiumTier } from '@root/entities/premium'

type TierIconProps = {
  tier: PremiumTier | undefined
  size?: number
}

export const TierIcon: React.FC<TierIconProps> = ({ tier, size = 10 }) => {
  const iconSrc = tier ? TIER_ICON_MAP[tier] : SPLASH_POINTS

  return (
    <Root
      style={{
        backgroundImage: iconSrc ? DomUtil.cssUrl(iconSrc) : undefined,
        width: size,
        height: size,
      }}
    ></Root>
  )
}

const Root = styled.div`
  background-size: contain;
  background-position: center center;
  background-repeat: no-repeat;
`

const TIER_ICON_MAP: Record<PremiumTier, string> = {
  'diamond-1': DIAMOND_1,
  'diamond-2': DIAMOND_2,
  'diamond-3': DIAMOND_3,

  'gold-1': GOLD_1,
  'gold-2': GOLD_2,
  'gold-3': GOLD_3,

  'platinum-1': PLATINUM_1,
  'platinum-2': PLATINUM_2,
  'platinum-3': PLATINUM_3,

  elite: ELITE,
}
